export default __webpack_public_path__ + "static/media/overview-placeholder.75d5da62.jpg";